"use client";

import { SpecOptionPills } from "@/components/listing/FurnitureOptionalDimensionsFields";
import {
  KITCHEN_CABINET_MOUNT_TYPES,
  type KitchenCabinetMountType,
  type KitchenCabinetSpecFormState,
} from "@/lib/listing/kitchenCabinetListingSpec";
import { cn } from "@/lib/utils";

interface KitchenCabinetSpecFieldsProps {
  value: KitchenCabinetSpecFormState;
  onChange: (next: KitchenCabinetSpecFormState) => void;
  className?: string;
}

function formatMountLabel(value: KitchenCabinetMountType): string {
  return value === "floor" ? "Floor" : "Hanging";
}

/**
 * Step 2 panel for canonical `kitchen-cabinet` (Wave 2 kitchen cabinet mount).
 * Mount required (floor | hanging).
 */
export default function KitchenCabinetSpecFields({
  value,
  onChange,
  className = "",
}: KitchenCabinetSpecFieldsProps) {
  return (
    <div className={cn("space-y-6", className)}>
      <div className="space-y-2">
        <p className="text-sm font-medium text-foreground">
          How is it mounted? <span className="text-red-500">*</span>
        </p>
        <SpecOptionPills
          options={[...KITCHEN_CABINET_MOUNT_TYPES]}
          selected={value.kitchenCabinetMountType}
          onSelect={(kitchenCabinetMountType: KitchenCabinetMountType) =>
            onChange({ ...value, kitchenCabinetMountType })
          }
          formatLabel={formatMountLabel}
        />
      </div>
    </div>
  );
}
